export default "__VITE_ASSET__BJhZ1MWc__"